import { AnimationStatus } from "./types";

export interface SetAnimationStatusAction {
  type: "SET_ANIMATION_STATUS";
  data: AnimationStatus;
}

export function setAnimationStatus(
  status: AnimationStatus
): SetAnimationStatusAction {
  return {
    data: status,
    type: "SET_ANIMATION_STATUS",
  };
}
